import React from "react";
import "./PNUDTitleSection.css";

export default function PNUDTitleSection({
  title1,
  title2,
  descriptionParagraphs,
  additionalContent,
  postCTAContent,
  image,
  callToActionElement,
}) {
  return (
    <div className="pnud-section-header">
      <div className="pnud-section-text">
        <h1 className="pnud-section-title">
          <span style={{ color: "black" }}>{title1}</span>{" "}
          <span style={{ color: "var(--pnud-gold)" }}>{title2}</span>
        </h1>
        <div className="padding-right">
          <div className="pnud-section-description">
            {descriptionParagraphs.map((paragraph, index) => {
              return <p key={index}>{paragraph}</p>;
            })}
            {additionalContent ?? null}
          </div>

          <div className="pnud-section-cta hidden-small">
            {callToActionElement}
          </div>
          {postCTAContent ?? null}
        </div>
      </div>
      <div className="pnud-section-image-container ">
        <img
          alt="Page Header"
          src={require("./../../../images/dashboard/" + image)}
          className="pnud-section-image"
        />
      </div>
      <div className="pnud-section-cta hidden-large">{callToActionElement}</div>
    </div>
  );
}
